import type { ComponentPropsWithoutRef, FC } from 'react';
import { Hint } from 'src/components/text/hint';
import { cn } from 'src/utils/cn';

/**
 * @deprecated Use `--spacing-lg` instead.
 */
export const cardGap = '1.5rem';

export type CardComponentProps = {
  hint?: string;
  mode?: 'default' | 'highlight' | 'embedded';
} & ComponentPropsWithoutRef<'div'>;

export function getCardStyles({
  mode,
  className,
}: {
  mode: CardComponentProps['mode'];
  className?: string;
}) {
  return cn(
    `
      rounded-xs p-xl
      legacy:rounded-none legacy:p-[1.5rem]
    `,
    mode === 'default' &&
      `
        border border-border-surface-minimal bg-white
        legacy:border-legacy-brand-light-3
        legacy:shadow-[0_0.1rem_0.1rem_rgba(0,0,0,0.05)]
      `,
    mode === 'highlight' &&
      `
        bg-background-surface-minimal
        legacy:bg-legacy-brand-light-5
      `,
    mode === 'embedded' &&
      `
        rounded-none bg-white shadow-indentation-sm
        legacy:border-t-0 legacy:border-r legacy:border-b legacy:border-l
        legacy:border-r-legacy-background legacy:border-b-legacy-brand-border
        legacy:border-l-legacy-background
        legacy:shadow-[inset_0.1rem_0.4rem_1rem_-0.6rem_rgba(0,0,0,0.5)]
      `,
    className
  );
}

export const Card: FC<CardComponentProps> = ({
  mode = 'default',
  hint,
  ...props
}) => {
  return (
    <div
      className={cn(
        `grid grid-rows-[1fr_auto] items-stretch`,
        hint &&
          `
            gap-md
            legacy:gap-[1rem]
          `
      )}
    >
      <div
        {...props}
        className={cn(getCardStyles({ mode, className: props.className }))}
      />
      {hint && <Hint>{hint}</Hint>}
    </div>
  );
};
